import React, { useState, useRef, useEffect } from "react";
import { Button, Box, Typography, Snackbar } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useUploadImageMutation } from '../../services/product';
const API_URI = process.env.REACT_APP_API_URI;

export default function UploadImage(props) {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const pasteRef = useRef(null);
  const [uploadImage, { isLoading }] = useUploadImageMutation();
  const [alert, setAlert] = useState(false);

  const handleSelectImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  useEffect(() => {
    if(props.record && props.record.IMAGE)
      setPreview(`${API_URI}/uploads/products/${props.record.IMAGE}`);
  }, [props.record]);

  useEffect(() => {
    const handlePaste = (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      for (const item of items) {
        if (item.type.startsWith("image/")) {
          const file = item.getAsFile();
          setImage(file);
          setPreview(URL.createObjectURL(file));
          break;
        }
      }
    };

    const node = pasteRef.current;
    if (node) node.addEventListener("paste", handlePaste);
    return () => node?.removeEventListener("paste", handlePaste);
  }, []);

  const handleUpload = async () => {
    if (!image) return setAlert("Please select or paste an image first!");

    const formData = new FormData();
    formData.append("file", image);
    formData.append("data", JSON.stringify({stylecol: props.record.STYLE+props.record.COLOR}));

    try {
      const result = await uploadImage(formData).unwrap();
      props.setAlert("Uploaded successfully!");
      props.uploadResult(result);
    } catch (err) {
      setAlert("Upload failed!");
      console.error(err);
    }
  };

  return (
    <Box
      ref={pasteRef}
      sx={{
        textAlign: "center",
        p: 3,
        border: "2px dashed #ccc",
        borderRadius: 2,
        backgroundColor: "#fafafa",
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Upload or Paste Image
      </Typography>

      {preview ? (
        <Box sx={{ mb: 2 }}>
          <img
            src={preview}
            alt="preview"
            style={{
              maxWidth: "200px",
              borderRadius: "8px",
              border: "1px solid #ccc",
            }}
          />
        </Box>
      ) : (
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          👉 Paste an image (Ctrl + V) or select a file below
        </Typography>
      )}

      <input
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        id="upload-input"
        onChange={handleSelectImage}
      />
      <label htmlFor="upload-input">
        <Button
          variant="outlined"
          component="span"
          startIcon={<CloudUploadIcon />}
          sx={{ mr: 2 }}
        >
          Select Image
        </Button>
      </label>

      <Button
        variant="contained"
        disabled={!image || isLoading}
        onClick={handleUpload}
      >
        {isLoading ? "Uploading..." : "Upload"}
      </Button>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
      />
    </Box>
  );
}
